import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import { sortByKey } from "@notemeal/utils-sort";
import { sortExchangeFn } from "../../Exchange/utils";
import { Carousel } from "../../global/Carousel";
import { MealItemContainer } from "../../Meal";
import { formatMeal } from "../../Meal/utils";
const useStyles = makeStyles((theme) => createStyles({
    root: {
        height: `100%`,
        boxSizing: "border-box",
        margin: 0,
    },
}));
export const MealTemplateView = ({ meal, label, containerWidth, mealOptions = [], renderMealOption = () => null, exchangeTargets = [], renderExchangeTarget = () => null, }) => {
    const classes = useStyles();
    // Public meal plan query does not hit local resolvers, so we calculate the macros for that case
    // getServingMacros returns macros on serving if present, so don't have to worry about this being expensive in the other case.
    const sortedMealOptions = sortByKey(mealOptions, "position").map(mo => ({
        ...mo,
        servingAmounts: mo.servingAmounts.map(sa => ({
            ...sa,
            serving: {
                ...sa.serving,
            },
        })),
    }));
    const sortedExchangeTargets = exchangeTargets.sort(({ exchange: e1 }, { exchange: e2 }) => sortExchangeFn(e1, e2));
    return (_jsxs(MealItemContainer, { className: classes.root, children: [_jsxs("div", { children: [_jsx(Typography, { variant: "body1Medium", color: "inherit", children: formatMeal(meal) }), label] }), !!sortedMealOptions.length && _jsx(Carousel, { items: sortedMealOptions, renderItem: renderMealOption, width: containerWidth }), !!sortedExchangeTargets.length && (_jsx(Carousel, { items: sortedExchangeTargets, renderItem: renderExchangeTarget, width: containerWidth }))] }));
};
//# sourceMappingURL=index.js.map